// extracted by mini-css-extract-plugin
export default {"create":"Create_create__TllU5"};